var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlayerComp"},[_c('audio',{attrs:{"id":"myAudio","src":require('@/commons/mp3/chen.mp3')}})])}
var staticRenderFns = []

export { render, staticRenderFns }